import { Input } from '@leroy-merlin-br/backyard-react-ui'
import { Controller } from 'react-hook-form'

const TextField = ({ control, name, rules, ...props }) => (
  <Controller
    name={name}
    rules={rules}
    control={control}
    render={({ onChange, ref, value }) => <Input name={name} ref={ref} value={value} onChange={onChange} {...props} />}
  />
)

export default TextField
